import React from 'react';
import { NavLink as Link } from 'react-router-dom';
import { Menu, Layout, Icon } from 'antd';
import NavUI from './NavUI';
import { AnimatedStickerIcon , TagIcon } from '../CustomIcon';

import '../../styles/Guide.css'
import { FormattedMessage } from 'react-intl';

const GuideNav = props => {

  const packTypePages = [
    {
      key:'plusPack',
      pathname:'/guide/PLUS',
      title:{
        id:'Guide.nav.PLUS',
        text:'Plus Pack'
      }
    },
    {
      key:'basicPack',
      pathname:'/guide/BASIC',
      title:{
        id:'Guide.nav.BASIC',
        text:'Basic Pack'
      }
    },
  ]

  const movingStatusPages = [{
      key:'animatedSticker',
      pathname:'/guide/animatedSticker',
      title:{
        id:'Guide.nav.animatedSticker',
        text:'Animated Sticker'
      }
    },
    {
      key:'stillImageSticker',
      pathname:'/guide/stillImageSticker',
      title:{
        id:'Guide.nav.stillImageSticker',
        text:'Still Image Sticker'
      }
    }
  ]

  const otherPages = [
    {
      key:'selectTags',
      pathname:'/guide/selectTags',
      icon: <TagIcon/>,
      title:{
        id:'Guide.nav.selectTags',
        text:'How to Select Tags'
      }
    },
    {
      key:'rejectedReasons',
      pathname:'/guide/rejectedReasons',
      icon:'file-search',
      title:{
        id:'Guide.nav.rejectedReasons',
        text:'Guide to Reject Reasons'
      }
    },
    {
      key:'channel',
      pathname:'/guide/channel',
      icon:'mobile',
      title:{
        id:'Guide.nav.channel',
        text:'Channel'
      }
    },
    {
      key:'faq',
      pathname:'/guide/faq',
      icon:'bulb',
      title:{
        id:'FAQ.headline',
        text:'FAQ'
      }
    },
  ]

  const createMenuItems = (pageData) => (
    <Menu.Item key={pageData.key}>
      <Link to={pageData.pathname}className="upload-nav" activeClassName="upload-nav-active">
        <div className="upload-nav-box">
          { React.isValidElement(pageData.icon) ? pageData.icon : <Icon type={pageData.icon} style={{fontSize: 18}}/>}
          <FormattedMessage
              id={pageData.title.id}
              defaultMessage={pageData.title.text}
              />
        </div>
      </Link>
    </Menu.Item>
  )

  return(
    <Layout.Sider theme='light' width='215' className='upload-nav-sider'>
      <Menu
        mode="inline"
        defaultSelectedKeys={[props.selectedKey]}
        defaultOpenKeys={[props.openKey]}
        style={{height:'100%', paddingTop: 44}}
      >
        <Menu.SubMenu
          key='packType'
          title={
            <div className='upload-nav-box'>
              <Icon type='desktop' style={{fontSize: 18}}/>
              <FormattedMessage
                id='Guide.nav.packType'
                defaultMessage='How to make'
              />
            </div>
          }
        >
        { packTypePages.map(createMenuItems) }
        </Menu.SubMenu>
        <Menu.SubMenu
          key='movingStatus'
          title={
            <div className='upload-nav-box'>
              <Icon type='smile-o' style={{fontSize: 18}}/>
              <FormattedMessage
                id='Guide.nav.movingStatus'
                defaultMessage='Sticker Type'
              />
            </div>
          }
        >
        { movingStatusPages.map(createMenuItems) }
        </Menu.SubMenu>
        {
          otherPages.map( pageData  =>
            <Menu.Item key={pageData.key}>
                <Link to={pageData.pathname}className="upload-nav" activeClassName="upload-nav-active">
                  <div className="upload-nav-box">
                    { React.isValidElement(pageData.icon) ? pageData.icon : <Icon type={pageData.icon} style={{fontSize: 18}}/>}
                    <FormattedMessage
                        id={pageData.title.id}
                        defaultMessage={pageData.title.text}
                        />
                  </div>
                </Link>
            </Menu.Item>
          )
        }
      </Menu>
    </Layout.Sider>
  )
};


export default GuideNav;
